'use strict';

var _forEach = require('lodash/forEach');

var _forEach2 = _interopRequireDefault(_forEach);

var _find = require('lodash/find');

var _find2 = _interopRequireDefault(_find);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _toPairs = require('lodash/toPairs');

var _toPairs2 = _interopRequireDefault(_toPairs);

var _first = require('lodash/first');

var _first2 = _interopRequireDefault(_first);

var _filter = require('lodash/filter');

var _filter2 = _interopRequireDefault(_filter);

var _pull = require('lodash/pull');

var _pull2 = _interopRequireDefault(_pull);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _uuid = require('uuid');

var _reporter = require('../../reporter');

var _reporter2 = _interopRequireDefault(_reporter);

var _applicationState = require('../../../utils/applicationState');

var _targetBuilder = require('../../../utils/targetBuilder');

var _targetBuilder2 = _interopRequireDefault(_targetBuilder);

var _configUtils = require('../../../utils/configUtils');

var _configUtils2 = _interopRequireDefault(_configUtils);

var _htmlUtils = require('../../../utils/htmlUtils');

var _htmlUtils2 = _interopRequireDefault(_htmlUtils);

var _parseUtils = require('../../../utils/parseUtils');

var _parseUtils2 = _interopRequireDefault(_parseUtils);

var _adsSettings = require('../../../utils/adsSettings');

var _adsSettings2 = _interopRequireDefault(_adsSettings);

var _uamNetworkController = require('../../networks/uamNetworkController');

var _uamNetworkController2 = _interopRequireDefault(_uamNetworkController);

var _PausableAdTimer = require('../../../utils/PausableAdTimer');

var _PausableAdTimer2 = _interopRequireDefault(_PausableAdTimer);

var _displayAdHandlers = require('./displayAdHandlers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var displayAdController = {
  slotDataArray: [],
  slotsChanged: false,
  isInitialized: false,
  init: function init() {
    var _this = this;

    if (!this.isInitialized) {
      // listen to DFP events
      googletag.cmd.push(function () {
        var partnerId = (0, _applicationState.getState)(_applicationState.State.partnerId);
        var options = (0, _applicationState.getState)(_applicationState.State.options);

        // TUNE-11772, https://support.google.com/admanager/answer/2880055
        googletag.pubads().setPublisherProvidedId((0, _applicationState.getState)(_applicationState.State.ppid));
        googletag.pubads().enableSingleRequest();
        googletag.enableServices();

        googletag.pubads().addEventListener('impressionViewable', _displayAdHandlers.onView.bind(_this));
        googletag.pubads().addEventListener('slotRenderEnded', _displayAdHandlers.onImpression.bind(_this));
        googletag.pubads().setTargeting('partnerId', partnerId);

        var areSafeFramesEnabled = _parseUtils2.default.parseBool((0, _get2.default)(options, 'ads.safeframes.enabled'));
        if (areSafeFramesEnabled) {
          googletag.pubads().setSafeFrameConfig({
            allowOverlayExpansion: false,
            allowPushExpansion: false,
            sandbox: true
          });
          googletag.pubads().setForceSafeFrame(true);
        }

        var isSlotVisibilityExperimentEnabled = _parseUtils2.default.parseBool((0, _get2.default)(options, 'ads.pauseRefresh.enabled'));
        if (isSlotVisibilityExperimentEnabled) {
          (0, _displayAdHandlers.addSlotVisibilityChangeListener)(_this.slotDataArray);
        }
      });

      (0, _displayAdHandlers.setPubAdsConsentStatus)();

      _uamNetworkController2.default.init();

      // listen to focus event changes
      (0, _applicationState.addStateChangeListener)(_applicationState.State.tabFocus, _displayAdHandlers.onTabFocusChange.bind(this));

      // listen to ads enabled event changes
      this.canShowAds = _adsSettings2.default.canShowAds();

      var boundOnCanShowAdsChange = _displayAdHandlers.onCanShowAdsChange.bind(this);
      (0, _applicationState.addStateChangeListener)(_applicationState.State.selectedGuideId, boundOnCanShowAdsChange);
      (0, _applicationState.addStateChangeListener)(_applicationState.State.playerStatus, boundOnCanShowAdsChange);
      (0, _applicationState.addStateChangeListener)(_applicationState.State.adsEnabled, boundOnCanShowAdsChange);

      // render openX header script
      var options = (0, _applicationState.getState)(_applicationState.State.options);
      var openXHeader = (0, _get2.default)(options, 'ads.openx.url');
      if (openXHeader) {
        _htmlUtils2.default.addScript(openXHeader, true);
      }

      // initialization complete
      this.isInitialized = true;
    }
  },
  isRegistered: function isRegistered(slot) {
    return Boolean((0, _find2.default)(this.slotDataArray, ['mintSlot', slot]));
  },
  // TODO: Are we actually registering a format here?  Can a slot have multiple DFP formats?
  registerSlot: function registerSlot(slot) {
    var _this2 = this;

    if (slot) {
      var format = (0, _first2.default)((0, _filter2.default)(slot.formats, ['adProvider', 'dfp']));
      if (format) {
        googletag.cmd.push(function () {
          var dfpSlot = googletag.defineSlot(format.adUnitId, format.dimensions, slot.elementId);
          if (dfpSlot) {
            dfpSlot.addService(googletag.pubads());
            var slotData = {
              dfpSlot: dfpSlot,
              mintSlot: slot,
              canRefresh: false
            };
            var refreshRate = (0, _get2.default)(slot, 'formatDefinition.refreshRate') || _configUtils2.default.getGlobalRefreshRate();
            slotData.timer = new _PausableAdTimer2.default(_displayAdHandlers.onComplete.bind(_this2, slotData), refreshRate * 1000);
            _this2.slotDataArray.push(slotData);
            _this2.slotsChanged = true;
          }
        });
      }
    }
  },
  deregisterSlot: function deregisterSlot(slot) {
    var _this3 = this;

    if (slot) {
      var slotData = (0, _find2.default)(this.slotDataArray, ['mintSlot.elementId', slot.elementId]);
      if (slotData) {
        googletag.cmd.push(function () {
          googletag.destroySlots([slotData.dfpSlot]);
          (0, _pull2.default)(_this3.slotDataArray, slotData);
          if (slotData.timer.timerId) {
            slotData.timer.clear();
          }

          _this3.slotsChanged = true;
        });
      }
    }
  },
  // TODO: Pass in format, use that format
  serveAd: function serveAd(params) {
    var _this4 = this;

    var slot = params.slot;

    return new Promise(function (resolve) {
      var options = (0, _applicationState.getState)(_applicationState.State.options);
      var bannerAdsEnabled = _parseUtils2.default.parseBool((0, _get2.default)(options, 'bannerads.enabled', true));
      var videoPrerollPlaying = (0, _applicationState.getState)(_applicationState.State.isPlayingVideoPreroll);

      if (!_this4.isInitialized || !slot || !_adsSettings2.default.canShowAds() || !bannerAdsEnabled) {
        resolve();
        return;
      }

      // we don't want to request ads when a videoPreroll is playing
      if (videoPrerollPlaying) {
        _this4.clearSlot(slot);
        resolve();
        return;
      }

      slot.requestId = (0, _uuid.v4)().toString();
      _this4.slotRefreshTriggered = false;
      googletag.cmd.push(function () {
        var slotData = (0, _find2.default)(_this4.slotDataArray, ['mintSlot.elementId', slot.elementId]);
        if (!slotData) {
          resolve();
          return;
        }

        slotData.dfpSlot.clearTargeting();
        var targetingInfo = _targetBuilder2.default.build();

        // we only want to set the prerollAdId if its in the app state
        var prerollAdId = (0, _applicationState.getState)(_applicationState.State.prerollAdId);
        if (prerollAdId) {
          targetingInfo.prerollAdId = prerollAdId;
          // prerollAdId should be reset to prevent subsequent companion banners from inheriting it
          (0, _applicationState.updateState)(_applicationState.State.prerollAdId, undefined);
        }

        // we only want to set the prerollCreativeId if its in the app state
        var prerollCreativeId = (0, _applicationState.getState)(_applicationState.State.prerollCreativeId);
        if (prerollCreativeId) {
          targetingInfo.prerollCreativeId = prerollCreativeId;
          // prerollAdId should be reset to prevent subsequent companion banners from inheriting it
          (0, _applicationState.updateState)(_applicationState.State.prerollCreativeId, undefined);
        }

        // We don't want to set the campaignId as a targeting parameter for
        // display ads if we are outside of the unlocked time period since this
        // prevents the ads from refreshing after the premium unlock takeover
        // ads. Removing the campaignId from the targeting parameters allows the
        // ads to refresh as usual since the campaignId designates that a unlock
        // takeover ad should be served.
        if (!_adsSettings2.default.isUnlocked() && (0, _get2.default)(targetingInfo, 'campaignId')) {
          delete targetingInfo.campaignId;
        }

        (0, _forEach2.default)((0, _toPairs2.default)(targetingInfo), function (pair) {
          slotData.dfpSlot.setTargeting(pair[0], pair[1]);
        });

        if (_this4.slotsChanged) {
          _this4.slotsChanged = false;
        }

        var amazonBidderEnabled = !!((0, _get2.default)(options, 'ads.amazonBidder.isEnabled', false) === 'true' && apstag);
        if (amazonBidderEnabled) {
          apstag.fetchBids({
            slots: [{
              slotID: slot.elementId,
              slotName: slot.formatDefinition.adUnitId,
              sizes: slot.formatDefinition.dimensions
            }],
            timeout: 2e3
          }, function () {
            _displayAdHandlers.showOrRefreshAds.bind(_this4)(amazonBidderEnabled, slotData, slot);
          });
        } else {
          _displayAdHandlers.showOrRefreshAds.bind(_this4)(amazonBidderEnabled, slotData, slot);
        }

        _reporter2.default.request(slot);

        if (slotData.timer.timerId) {
          slotData.timer.clear();
        }

        var isSlotVisibilityExperimentEnabled = _parseUtils2.default.parseBool((0, _get2.default)(options, 'ads.pauseRefresh.enabled'));
        // in case we loaded an ad and its not visible to the user,
        // when pauseRefresh is enabled and the ad is scrolled into view,
        // then the addSlotVisibilityChangeListener will resume the timer.
        // The timer is initially instantiated in a "paused" state.
        if (isSlotVisibilityExperimentEnabled && !slot.isAdSlotVisible()) {
          resolve();
          return;
        }

        // start the timer
        slotData.timer.resume();

        resolve();
      });
    });
  },
  clearSlot: function clearSlot(slot, shouldIgnoreAdVisibilityEventOnce) {
    if (slot) {
      var $slotEl = (0, _jquery2.default)('#' + slot.elementId);
      if ($slotEl) {
        $slotEl.empty();
        $slotEl.off();
      }

      // fetch slot data for this slot
      var slotData = (0, _find2.default)(this.slotDataArray, ['mintSlot.elementId', slot.elementId]);
      if (slotData) {
        // this is set so that adVisibilityEvent is ignored once for this ad, since we want the
        // timer NOT to be paused in this case. See displayAdHandlers.slotVisibilityChangeHandler
        // We also don't want to set canRefresh to false in this case since that will cause the slot
        // to be cleared and a one cycle delay in the ad refresh.
        // See showOrRefreshAds in displayAdHandlers.
        if (shouldIgnoreAdVisibilityEventOnce) {
          slotData.shouldIgnoreAdVisibilityEventOnce = shouldIgnoreAdVisibilityEventOnce;
          return;
        }

        slotData.canRefresh = false;
      }
    }
  },
  releaseSlot: function releaseSlot(slot) {
    if (!slot) {
      return;
    }

    // fetch slot data for this slot
    var releaseSlotData = (0, _find2.default)(this.slotDataArray, ['mintSlot.elementId', slot.elementId]);
    if (!releaseSlotData) {
      return;
    }

    // clear refresh timeout
    if (releaseSlotData.timer.timerId) {
      releaseSlotData.timer.clear();
    }

    // clear focus handler
    if (releaseSlotData.onTabFocus) {
      (0, _applicationState.removeStateChangeListener)(_applicationState.State.tabFocus, releaseSlotData.onTabFocus);
      releaseSlotData.onTabFocus = undefined;
    }
  }
};

module.exports = displayAdController;